// تفاعلات واجهة صفحة الدخول: قائمة اللغة، الوضع الداكن، التوهج، Caps Lock، العدّاد
(function () {
	const root = document.documentElement;
	const LANG_COOKIE = "preferred_language";
	const THEME_KEY = "theme_login_mode";
	const reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

	const $$ = (sel, ctx = document) => Array.from(ctx.querySelectorAll(sel));

	// نموذج التسجيل القادم من Frappe (signup_form_template): نصوصه مترجمة من الخادم، نضبط الشكل فقط
	function annotateSignupForm() {
		const form = document.querySelector(".form-signup");
		if (!form) return;

		["#signup_fullname", "#signup_email"].forEach((sel) => {
			const input = form.querySelector(sel);
			if (!input) return;
			input.setAttribute("dir", "auto");
			form.querySelector(`label[for="${input.id}"]`)?.classList.remove("sr-only");
		});

		const btn = form.querySelector(".btn-signup");
		if (btn && !btn.querySelector(".btn-label")) {
			const label = document.createElement("span");
			label.className = "btn-label";
			label.textContent = btn.textContent.trim();
			const spinner = document.createElement("span");
			spinner.className = "ml-spinner";
			spinner.setAttribute("aria-hidden", "true");
			btn.classList.add("ml-btn");
			btn.replaceChildren(label, spinner);
		}
	}

	// نفس آلية Frappe: cookie preferred_language ثم إعادة تحميل الصفحة ليحدد الخادم اللغة والاتجاه والنصوص
	function setLang(lang) {
		document.cookie = `${LANG_COOKIE}=${lang}; path=/; max-age=31536000; SameSite=Lax`;
		const url = new URL(location.href);
		// الباراميتر _lang يتقدم على الـ cookie في Frappe فنزيله حتى لا يمنع التبديل
		if (url.searchParams.has("_lang")) {
			url.searchParams.delete("_lang");
			location.replace(url);
		} else {
			location.reload();
		}
	}

	function bindLangMenu() {
		const btn = document.getElementById("ml-lang-btn");
		const menu = document.getElementById("ml-lang-menu");
		if (!btn || !menu) return;

		const toggle = (open) => {
			menu.hidden = !open;
			btn.setAttribute("aria-expanded", String(open));
		};
		btn.addEventListener("click", (e) => {
			e.stopPropagation();
			toggle(menu.hidden);
		});
		menu.addEventListener("click", (e) => {
			const item = e.target.closest("[data-lang]");
			if (!item) return;
			if (item.classList.contains("is-active")) return toggle(false);
			setLang(item.dataset.lang);
		});
		document.addEventListener("click", () => toggle(false));
		document.addEventListener("keydown", (e) => {
			if (e.key === "Escape" && !menu.hidden) {
				toggle(false);
				btn.focus();
			}
		});
	}

	function isDark() {
		const forced = root.getAttribute("data-theme");
		if (forced) return forced === "dark";
		return window.matchMedia("(prefers-color-scheme: dark)").matches;
	}

	function toggleTheme() {
		const next = isDark() ? "light" : "dark";
		root.setAttribute("data-theme", next);
		try {
			localStorage.setItem(THEME_KEY, next);
		} catch (e) {
			// التخزين غير متاح (وضع التصفح الخاص مثلاً)
		}
	}

	function bindCardGlow() {
		const card = document.getElementById("ml-card");
		if (!card || reduceMotion) return;
		card.addEventListener("pointermove", (e) => {
			const r = card.getBoundingClientRect();
			card.style.setProperty("--mx", `${e.clientX - r.left}px`);
			card.style.setProperty("--my", `${e.clientY - r.top}px`);
		});
	}

	function bindCapsLock() {
		const input = document.getElementById("login_password");
		const warn = document.querySelector(".ml-caps");
		if (!input || !warn) return;
		const check = (e) => {
			if (e.getModifierState) warn.hidden = !e.getModifierState("CapsLock");
		};
		input.addEventListener("keydown", check);
		input.addEventListener("keyup", check);
		input.addEventListener("blur", () => (warn.hidden = true));
	}

	function bindPasswordToggleKeys() {
		$$(".toggle-password").forEach((el) => {
			el.addEventListener("keydown", (e) => {
				if (e.key === "Enter" || e.key === " ") {
					e.preventDefault();
					el.click();
				}
			});
		});
	}

	function copyText(text) {
		if (navigator.clipboard && window.isSecureContext)
			return navigator.clipboard.writeText(text);
		// Clipboard API غير متاحة على المواقع عبر http فنستخدم الطريقة القديمة
		const ta = document.createElement("textarea");
		ta.value = text;
		ta.setAttribute("readonly", "");
		ta.style.cssText = "position:fixed;opacity:0;pointer-events:none";
		document.body.appendChild(ta);
		ta.select();
		const ok = document.execCommand("copy");
		ta.remove();
		return ok ? Promise.resolve() : Promise.reject();
	}

	// نسخ البريد مفيد لمن لا يملك برنامج بريد مرتبطاً بروابط mailto
	function bindCopy() {
		$$("[data-copy]").forEach((btn) => {
			let timer;
			btn.addEventListener("click", () => {
				copyText(btn.dataset.copy)
					.then(() => {
						btn.classList.add("is-copied");
						clearTimeout(timer);
						timer = setTimeout(() => btn.classList.remove("is-copied"), 1600);
					})
					.catch(() => {});
			});
		});
	}

	function countUp() {
		$$("[data-count]").forEach((el) => {
			const target = parseInt(el.dataset.count, 10) || 0;
			if (reduceMotion) return;
			const start = performance.now();
			const duration = 1800;
			const step = (now) => {
				const p = Math.min((now - start) / duration, 1);
				const eased = 1 - Math.pow(1 - p, 3);
				el.textContent = Math.round(target * eased).toLocaleString("en-US");
				if (p < 1) requestAnimationFrame(step);
			};
			el.textContent = "0";
			setTimeout(() => requestAnimationFrame(step), 700);
		});
	}

	function init() {
		annotateSignupForm();
		bindLangMenu();
		document.getElementById("ml-theme-btn")?.addEventListener("click", toggleTheme);

		bindCardGlow();
		bindCapsLock();
		bindPasswordToggleKeys();
		bindCopy();
		countUp();
	}

	if (document.readyState === "loading") {
		document.addEventListener("DOMContentLoaded", init);
	} else {
		init();
	}
})();
